import styles from './DimensionIndicator.module.css';

interface DimensionIndicatorProps {
  width: number
  height: number
}

export function DimensionIndicator({
  width,
  height,
}: DimensionIndicatorProps) {
  return (
    <div className={styles.dimensionIndicator}>
      {width}
      <small> ✕ </small>
      {height}
    </div>
  );
}
